import { GET } from './api';

const table = 'titulos';

// Titulos (parcelas) de cobranca, somente leitura. O escopo por distribuidor e
// aplicado no backend, atraves da cobranca, e cada item vem com a `cobranca`
// populada (com `cliente`, `banco` e `distribuidor`).
//
// E a fonte dos relatorios de baixa: o titulo guarda o estado final (estorno
// ja desfeito, um registro por parcela) e os campos da baixa sao filtraveis
// (`status`, `tipo_baixa`, `data_baixa`). Somar os logs `baixa` daria numero
// errado: o estorno nao apaga o log, a baixa em lote grava um log por parcela
// e mais um por contrato, e a renegociacao tambem grava log `baixa`.
export const Read = async (filters = '') => {
  return await GET(`/${table}${filters}`, true);
};

// Todos os titulos de uma cobranca, baixados inclusive, no estado atual. A aba
// Baixa do Historico relê por aqui depois de baixar ou estornar: o
// `dados.titulos` do modal e a foto da listagem e fica velho na hora.
export const ReadByCobranca = async (id) => {
  return await GET(
    `/${table}?filters[cobranca][id][$eq]=${id}&sort=parcela:asc&pagination[pageSize]=1000`,
    true
  );
};
